var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.709 7.28688C18.9374 7.28576 18.1977 6.97865 17.6522 6.43291C17.1068 5.88717 16.8 5.14736 16.7993 4.37576V0.337158H3.7973C2.79019 0.337158 1.82434 0.737224 1.11221 1.44936C0.400074 2.16149 0 3.12736 0 4.13446V27.0255C0.00149555 28.0316 0.402226 28.996 1.1142 29.707C1.82617 30.4179 2.79117 30.8172 3.7973 30.8172H19.4056C20.4117 30.8172 21.3767 30.4179 22.0887 29.707C22.8007 28.996 23.2014 28.0316 23.2029 27.0255V7.28688H19.709Z",
    fill: "#FF9908"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2025 7.28688H19.7085C18.9369 7.28576 18.1973 6.97865 17.6518 6.43291C17.1063 5.88717 16.7996 5.14736 16.7988 4.37576V0.337158L23.2025 7.28688Z",
    fill: "#FF9908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9557 24.4114H8.31117C7.05955 24.4114 6.04492 25.426 6.04492 26.6776V31.9382C6.04492 33.1899 7.05955 34.2045 8.31117 34.2045H25.9557C27.2073 34.2045 28.2219 33.1899 28.2219 31.9382V26.6776C28.2219 25.426 27.2073 24.4114 25.9557 24.4114Z",
    fill: "#FF9908"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0313 30.4465V31.4724H11.9688V30.4465H13.0313Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6275 30.6466H16.5V31.4749H13.4873V30.6946L15.3302 28.0544H13.5113V27.2317H16.4887V28.012L14.6275 30.6466Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1564 27.2317V31.4749H17.1348V27.2317H18.1564Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8911 29.9862V31.4749H18.8652V27.2317H20.5219C21.0256 27.2317 21.4109 27.3559 21.6748 27.607C21.8084 27.738 21.9128 27.8957 21.9811 28.0698C22.0494 28.2439 22.0802 28.4306 22.0713 28.6174C22.0757 28.8642 22.0143 29.1077 21.8935 29.323C21.7703 29.5334 21.5877 29.7028 21.3685 29.8098C21.1041 29.9341 20.814 29.9946 20.5219 29.9862H19.8911ZM21.0313 28.6174C21.0313 28.2458 20.8253 28.0577 20.4132 28.053H19.8911V29.1564H20.4132C20.8253 29.1612 21.0313 28.9815 21.0313 28.6174Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5989 21.86C11.1243 21.8592 10.6694 21.6703 10.334 21.3346C9.99853 20.9989 9.80994 20.5438 9.80957 20.0693V18.2786H13.3896V20.0693C13.3892 20.5441 13.2004 20.9993 12.8647 21.3351C12.5289 21.6708 12.0737 21.8596 11.5989 21.86ZM10.7254 19.1944V20.0693C10.7254 20.301 10.8174 20.5234 10.9811 20.6874C11.1449 20.8514 11.3671 20.9438 11.5989 20.9442C11.8308 20.9438 12.0531 20.8515 12.2171 20.6875C12.3811 20.5235 12.4734 20.3012 12.4737 20.0693V19.1944H10.7254Z",
    fill: "#FF9908"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80859 18.2786H11.6035V16.4836H9.80859V18.2786Z",
    fill: "#FF9908"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 16.4856H13.3945V14.6907H11.5996V16.4856Z",
    fill: "#FF9908"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80859 14.6926H11.6035V12.8977H9.80859V14.6926Z",
    fill: "#FF9908"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 12.8997H13.3945V11.1047H11.5996V12.8997Z",
    fill: "#FF9908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/ZIP.048d24945ffc13304407259da2ca7abc.svg";
export { ForwardRef as ReactComponent };